import { h, Fragment } from 'preact';
import CartServiceRequirementsMessage from '../cart/CartServiceRequirementsMessage';
import CartBlock from '../cart/CartBlock';
import FranchiseDisclaimerBlock from '../blocks/FranchiseDisclaimerBlock';
import AppointmentDetailsList from '../appointments/AppointmentDetailsList';
import PromotionFlashSaleBlock from '../promotions/PromotionFlashSaleBlock';
import WisetackBannerBlock from '../blocks/WisetackBannerBlock';


/**
 * Default Right Sidebar Component
 * Can be used as-is or customized per step
 *
 * @param {Object} props
 * @param {boolean} [props.showCartRequirements=true]
 * @param {boolean} [props.showAppointmentDetails=false]
 * @param {boolean} [props.showFlashSale=true]
 * @param {boolean} [props.showCart=true]
 * @param {boolean} [props.showFranchiseDisclaimer=true]
 * @param {boolean} [props.showWisetackBanner=true]
 * @param {preact.ComponentChildren} [props.children]
 */
export default function RightSidebar({
  showCartRequirements = false,
  showAppointmentDetails = false,
  showFlashSale = true,
  showCart = true,
  showFranchiseDisclaimer = true,
  showWisetackBanner = true,
  children
}) {
  return (
    <Fragment>
      {showCartRequirements && <CartServiceRequirementsMessage />}
      {showAppointmentDetails && <div className="hidden xl:flex xl:flex-col xl:gap-3.5"><AppointmentDetailsList /></div>}
      {showCart && <div className="hidden xl:block"><CartBlock showServiceItems={true} /></div>}
      {showFlashSale && <PromotionFlashSaleBlock />}
      {showWisetackBanner && <WisetackBannerBlock />}
      {showFranchiseDisclaimer && <FranchiseDisclaimerBlock />}
      {children}
    </Fragment>
  );
}
